import labels from "../../../helpers/labels.json";

export const sidebar_options = [
  {
    icon: require("../../../assets/images/my_cases.svg"),
    inactive: require("../../../assets/images/my_cases.svg"),
    title: labels.my_cases,
    path: "/transcriber/cases?caseType=mediation",
    listItems: [
      {
        icon: require("../../../assets/images/mediation-active.svg"),
        inactive: require("../../../assets/images/mediation-inactive.svg"),
        title: labels.my_cases_mediation,
        path: "/transcriber/cases?caseType=mediation",
      },
      {
        icon: require("../../../assets/images/mediation-active.svg"),
        inactive: require("../../../assets/images/mediation-inactive.svg"),
        title: labels.my_cases_arbitration,
        path: "/transcriber/cases?caseType=arbitration",
      },
    ],
  },
  {
    icon: require("../../../assets/images/config.png"),
    inactive: require("../../../assets/images/config.png"),
    title: labels.management_tools,
    path: "/transcriber/management-tools",
  },
];
